import classNames from 'classnames'
import React from 'react'
import styles from './Progress.module.scss'

export const Bar = ({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles.progress, className)} {...rest}>
    {children}
  </div>
)
